import React from 'react';
import { Card, Flex, Text } from '@aws-amplify/ui-react';
import { RatingDefinition } from '../../utils/PlaceDataUtils';
import { PublicUserProfile } from '../../types/user';
import StarRating from './StarRating';
import UserThumbnail from '../user/UserThumbnail';
import I18nTextUtils from '../../utils/i18n/I18nTextUtils';
import './RatingsList.css';

interface RatingsListProps {
    ratings: RatingDefinition[];
    ratingCreatorProfiles: { [key: string]: PublicUserProfile | null };
    currentUserId?: string; // Optional: current logged-in user ID for dynamic image loading
}

export default function RatingsList({ ratings, ratingCreatorProfiles, currentUserId }: RatingsListProps) {
    return (
        <Flex
            className="ratings-list-container"
            direction="column"
            gap="medium"
        >
            {ratings.map((rating) => (
                <Card
                    className="rating-item-card"
                    key={rating.id}
                    variation="outlined"
                >
                    <Flex 
                        direction="row" 
                        gap="medium"
                        wrap="wrap"
                    >
                        <Flex 
                            direction="column" 
                        gap="small"
                        >
                            <StarRating
                                rating={rating.rating}
                                readOnly={true}
                                size="small"
                            />
                            <UserThumbnail userProfile={ratingCreatorProfiles[rating.id]} currentUserId={currentUserId} />
                        </Flex>
                        <Text whiteSpace="pre-wrap" textAlign="left">{I18nTextUtils.resolveInternationalizedText(rating.ratingText)}</Text>
                    </Flex>
                </Card>
            ))}
        </Flex>
    );
} 